import { DatePicker } from 'antd';
import './DatePickerComponent.scss';
import { Icon } from '../../icon/icon';

const DatePickerComponent = ({
  style,
  label,
  id,
  placeholder,
  size = 'large',
  icon,
  footerExtra,
  ...props
}) => {
  return (
    <DatePicker
      id={id}
      // onChange={(date, dateString) => {
      //     console.log(date, dateString);
      // }}
      style={style}
      suffixIcon={icon ?? <Icon.ICCalendar width={16} height={16} />}
      superNextIcon={null}
      superPrevIcon={null}
      nextIcon={
        <div className="w-[16px] h-[16px]">
          <Icon.ICArrowForward />
        </div>
      }
      prevIcon={
        <div className="w-[16px] h-[16px]">
          <Icon.ICArrowBack />
        </div>
      }
      placeholder={placeholder}
      size={size}
      allowClear={true}
      format="DD/MM/YYYY"
      renderExtraFooter={() => {
        return <>{footerExtra}</>;
      }}
      locale={'vi_VN'}
      {...props}
    />
  );
};

export default DatePickerComponent;
